module.exports = __webpack_public_path__ + "img/travelling-thali.9bd9ce64.jpg";